import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import HomeContactForm from '../components/HomeContactForm';
import { useTheme } from '../context/ThemeContext';
import busImg from '../assets/images/misc/bus.png';
import fs1 from '../assets/images/misc/forschool-1.jpg';
import fs11 from '../assets/images/misc/forschool-11.jpg';
import fs2 from '../assets/images/misc/forschool-2.jpg';
import fs21 from '../assets/images/misc/forschool-21.jpg';
import fs3 from '../assets/images/misc/forschool-3.jpg';
import fs31 from '../assets/images/misc/forschool-31.jpg';
import fs4 from '../assets/images/misc/forschool-4.jpg';
import fs41 from '../assets/images/misc/forschool-41.jpg';
import fs5 from '../assets/images/misc/forschool-5.jpg';
import fs51 from '../assets/images/misc/forschool-51.jpg';
import fs6 from '../assets/images/misc/forschool-6.jpg';
import fs61 from '../assets/images/misc/forschool-61.jpg';
import fs7 from '../assets/images/misc/forschool-7.jpg';
import fs71 from '../assets/images/misc/forschool-71.jpg';
import fs8 from '../assets/images/misc/forschool-8.jpg';
import fs81 from '../assets/images/misc/forschool-81.jpg';

const Schools = () => {
    const busRef = useRef(null);
    const canvasRef = useRef(null);
    const { theme } = useTheme();

    useEffect(() => {
        const canvas = canvasRef.current;
        const bus = busRef.current;
        if (!canvas || !bus) return;

        const context = canvas.getContext('2d');
        const pathAmplitude = 15; // Amplitude of the sine wave
        const pathFrequency = 0.005; // Frequency of the sine wave

        // Set canvas dimensions
        const setCanvasDimensions = () => {
            canvas.width = window.innerWidth;
            canvas.height = 6000; // Match the height set in CSS
            drawSineWave();
        };

        // Function to draw sine wave path with dashed lines
        const drawSineWave = () => {
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.beginPath();
            context.setLineDash([10, 15]); // Dashed line style
            context.moveTo(canvas.width / 2, 0);

            for (let y = 0; y < canvas.height; y++) {
                const x = pathAmplitude * Math.sin(pathFrequency * y) + canvas.width / 2;
                context.lineTo(x, y);
            }

            // Get color from CSS variable or default to black
            const roadColor = getComputedStyle(document.body).getPropertyValue('--road-color').trim();
            context.strokeStyle = roadColor || 'black';
            context.stroke();
        };

        // Function to calculate the angle of the sine wave at a given y position
        const calculateAngle = (y) => {
            const dx = 1; // Small change in y to calculate the derivative
            const dy = pathAmplitude * (Math.sin(pathFrequency * (y + dx)) - Math.sin(pathFrequency * y));
            return Math.atan2(dy, dx) * (180 / Math.PI); // Convert angle to degrees
        };

        const handleScroll = () => {
            bus.style.display = 'block';
            const scrollTop = window.scrollY;
            const busY = scrollTop;
            const busX = pathAmplitude * Math.sin(pathFrequency * scrollTop) + (window.innerWidth / 2) - (bus.offsetWidth / 2);
            const angle = calculateAngle(scrollTop);

            bus.style.transform = `translate(${busX}px, ${busY}px) rotate(${angle}deg)`;
        };

        // Initial setup
        setCanvasDimensions();
        window.addEventListener('resize', setCanvasDimensions);
        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Initial call to show bus if in view

        return () => {
            window.removeEventListener('resize', setCanvasDimensions);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [theme]);

    return (
        <>


            {/* Page Header */}
            <section id="main-banner-page" className="position-relative page-header about-header parallax section-nav-smooth">
                <div className="overlay overlay-dark opacity-6"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 offset-lg-3">
                            <div className="page-titles whitecolor text-center padding_top padding_bottom">
                                <h2 className="font-bold">myskoolbus Pro</h2>
                                <h2 className="font-xlight">How it works</h2>
                            </div>
                        </div>
                    </div>
                    <div className="gradient-bg title-wrap">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 whitecolor">
                                <h3 className="float-left">How it works for Transport Dept.</h3>
                                <ul className="breadcrumb top10 bottom10 float-right">
                                    <li className="breadcrumb-item hover-light"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item hover-light">How it works</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Page Header ends */}

            {/* Timeline */}
            <div className="timeline" style={{ minHeight: '2000px' }}>
                <img ref={busRef} src={busImg} alt="Bus" className="bus" id="bus" />
                <canvas ref={canvasRef} id="sineWaveCanvas"></canvas>

                <section className="padding_top padding_bottom" style={{ maxWidth: '1140px', marginLeft: 'auto', marginRight: 'auto' }}>

                    <div className="timelinecontainer right">
                        <div className="content additionalText">
                            <h4>At the start of the academic year, gathering and maintaining student details for school transport becomes a challenging and time-consuming task for the transport team</h4>
                        </div>
                    </div>

                    <div className="timelinecontainer left">
                        <div className="content">
                            <div className="description">
                                <img src={fs1} alt="school" />
                                <p>Myskoolbus offers an intuitive interface for student data input, delivering an exceptional and user-friendly experience</p>
                            </div>
                            <div className="notification">
                                <div>
                                    School transport teams can efficiently upload bulk student data by simply using an excel file with a single click
                                </div>
                                <img src={fs11} className="img-fluid" alt="school" />
                            </div>
                        </div>
                    </div>

                    <div className="timelinecontainer right">
                        <div className="content additionalText">
                            <h4>Route creation, a one-time task for the transport team, allows them to design routes with maximum efficiency and optimal precision</h4>
                        </div>
                    </div>

                    <div className="timelinecontainer left">
                        <div className="content">
                            <div className="description">
                                <img src={fs2} alt="school" />
                                <p>Myskoolbus provides transport teams with user-friendly, map-based route-design tools, making it easy to plan and create highly efficient routes</p>
                            </div>
                            <div className="notification">
                                <div>
                                    The drag-and-drop feature for route creation simplifies route management, making it more efficient for schools to handle
                                </div>
                                <img src={fs21} alt="school" />
                            </div>
                        </div>
                    </div>

                    <div className="timelinecontainer right">
                        <div className="content additionalText">
                            <h4>Managing daily trips for thousands of students while ensuring no bus or student is missed is highly demanding</h4>
                        </div>
                    </div>

                    <div className="timelinecontainer left">
                        <div className="content">
                            <div className="description">
                                <img src={fs3} alt="school" />
                                <div className="notificationTime">Enhanced Communication Channel</div>
                                <p>Myskoolbus automates daily trip generation, eliminating the need for the transport team to manually handle the process</p>
                            </div>
                            <div className="notification">
                                <div>
                                    <em>Myskoolbus allows schools the convenience of manually generating trips with just a simple click if needed</em>
                                </div>
                                <img src={fs31} alt="school" />
                            </div>
                        </div>
                    </div>

                    <div className="timelinecontainer right">
                        <div className="content additionalText">
                            <h4>Live trip tracking and feature-rich dashboards are high-priority requests for every school transport team, enhancing their management efficiency</h4>
                        </div>
                    </div>

                    <div className="timelinecontainer left">
                        <div className="content">
                            <div className="description">
                                <img src={fs4} alt="school" />
                                <p>Myskoolbus equips the transport team with a comprehensive dashboard, offering a bird’s eye vew of all trips at a glance</p>
                            </div>
                            <div className="notification">
                                <div>
                                    School officials and transport teams can monitor trips in real-time through live tracking, gaining detailed insights into each student's boarding status, ensuring safety by knowing who has or hasn't boarded the bus.
                                </div>
                                <img src={fs41} alt="school" />
                            </div>
                        </div>
                    </div>

                    <div className="timelinecontainer right">
                        <div className="content additionalText">
                            <h4>Though uncommon, unexpected incidents can leave drivers stranded. In such cases, they can quickly send signals to the transport team for immediate assistance</h4>
                        </div>
                    </div>

                    <div className="timelinecontainer left">
                        <div className="content">
                            <div className="description">
                                <img src={fs5} alt="school" />
                                <p>Myskoolbus's driver/bus attendant app features an sos button that instantly alerts the transport team with one tap</p>
                            </div>
                            <div className="notification">
                                <div>
                                    Actions taken and response times are recorded for review by senior officials, ensuring accountability
                                </div>
                                <img src={fs51} alt="school" />
                            </div>
                        </div>
                    </div>

                    <div className="timelinecontainer right">
                        <div className="content additionalText">
                            <h4>Students frequently join multiple clubs and participate in various activities, often requiring them to stay at school, making it unnecessary for them to travel on regular drop-off routes</h4>
                        </div>
                    </div>

                    <div className="timelinecontainer left">
                        <div className="content">
                            <div className="description">
                                <img src={fs6} alt="school" />
                                <p>Myskoolbus offers a unique feature allowing teachers to mark students who stay back, enabling the transport team to assign them to new ad-hoc trips efficiently</p>
                            </div>
                            <div className="notification">
                                <div>
                                    Parents receive notifications and can track their children's location as they commute back home
                                </div>
                                <img src={fs61} alt="school" />
                            </div>
                        </div>
                    </div>

                    <div className="timelinecontainer right">
                        <div className="content additionalText">
                            <h4>Students sometimes leave early, causing bus attendants to search the entire school to find them</h4>
                        </div>
                    </div>

                    <div className="timelinecontainer left">
                        <div className="content">
                            <div className="description">
                                <img src={fs7} alt="school" />
                                <p>Myskoolbus enables schools to record details of students leaving early and flags them, ensuring bus attendants or drivers are informed and aware, preventing confusion during student pickups or departures</p>
                            </div>
                            <div className="notification">
                                <div>
                                    This ensures no more incorrect absence markings or inaccurate notifications sent to parents
                                </div>
                                <img src={fs71} alt="school" />
                            </div>
                        </div>
                    </div>

                    <div className="timelinecontainer right">
                        <div className="content additionalText">
                            <h4>At the end of each day or periodically, transport teams and school officials need to review trip summaries and track any recorded breaches for oversight and improvement</h4>
                        </div>
                    </div>

                    <div className="timelinecontainer left">
                        <div className="content">
                            <div className="description">
                                <img src={fs8} alt="school" />
                                <p>Myskoolbus offers schools detailed standard reports that provide a complete overview of bus operations, either as a whole or in specific segments</p>
                            </div>
                            <div className="notification">
                                <div>
                                    Myskoolbus offers comprehensive reports providing valuable insights into driver and bus attendant efficiency, compliance, student attendance trends, and the involvement of teachers, transport teams, and other key stakeholders. These insights ensure smooth operations
                                </div>
                                <img src={fs81} alt="school" />
                            </div>
                        </div>
                    </div>

                </section>
                {/* About us ends */}
            </div>
            {/* timeline */}

            {/* Contact US */}
            <section id="stayconnect" className="stay-connect-section bglight position-relative">
                <div className="container">
                    <div className="contactus-wrapp">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <div className="heading-title wow fadeInUp text-center text-md-left" data-wow-delay="300ms">
                                    <h3 className="darkcolor bottom20">Stay Connected</h3>
                                </div>
                            </div>
                            <div className="col-md-12 col-sm-12">
                                <div className="getin_form wow fadeInUp" data-wow-delay="400ms">

                                    <div className="wpcf7 no-js" id="wpcf7-f22-o1" lang="en-US" dir="ltr">
                                        <div className="screen-reader-response"><p role="status" aria-live="polite" aria-atomic="true"></p> <ul></ul></div>
                                        <HomeContactForm />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Contact US ends */}
        </>
    );
};

export default Schools;
